<div class="wccard rounded-lg p-2 border">
  <div class="row">
    <div class="col-2">
      <img [src]="integration.logo ? integration.logo : 'https://api.unified.to/docs/images/successfactors.png'" alt="Placeholder" class="img-fluid rounded">
    </div>
    <div class="col my-auto">
      <!-- action button -->
      <div class="d-flex justify-content-end f-12" *ngIf="integration.can_connect">
        <button data-testid="auto-app-integration-unit-button-1" class="btn text-webbtree-green rounded-pill f-14" style="background-color: #f2f2f2;" (click)="integration.type === 'aegis' ? disconnectAegisIntegration() : disconnectIntegration()" *ngIf="integration.user"><ng-container *ngIf="fetchInProgress"><i class="spinner-border"></i></ng-container><ng-container *ngIf="!fetchInProgress">Disconnect</ng-container></button>
        <button data-testid="auto-app-integration-unit-button-2" class="btn text-webbtree-green rounded-pill f-14" style="background-color: #e3f1f2;" (click)="integration.type === 'aegis' ? redirectToAegisAuthUrl() : redirectToAuthUrl()" *ngIf="!integration.user"><ng-container *ngIf="fetchInProgress"><i class="spinner-border"></i></ng-container><ng-container *ngIf="!fetchInProgress">Connect<i class="fa-arrow-up-right fa-regular ml-1"></i></ng-container></button>
      </div>
    </div>
  </div>
  <hr class="my-2">
  <div class="row">
    <div class="col-8">
      <p class="font-weight-500 mb-0 text-truncate" [title]="integration.name">{{ integration.name }}</p>
    </div>
    <div class="col-4" *ngIf="integration.type && false">
      <span class="badge border f-10 font-weight-normal text-9696 float-right" [title]="integration.type | titlecase">{{ integration.type | titlecase }}</span>
    </div>
  </div>
</div>
